import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import surfaceStore from '../store/surfaceStore';
import type { ClientItemId } from 'owa-client-ids';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';

export function getCalendarEventFromSurface(itemId: ClientItemId): CalendarEvent | undefined {
    // The find is inefficient.  Ideally we would use map for items.
    const findResult = findInArray(surfaceStore.calendarItems, item => {
        return item.ItemId.Id == itemId.Id;
    });

    return findResult?.item;
}
